export function sanitizeAgentVProviderBranding(value: string): string {
  return value
    .replace(/HeyGen Video Agent/gi, "Agent V")
    .replace(/HeyGen/gi, "Agent V")
    .replace(/heygen/gi, "Agent V");
}
